import { render, staticRenderFns } from "./AgDetailDocument.vue?vue&type=template&id=248fab3f&scoped=true"
import script from "./AgDetailDocument.vue?vue&type=script&lang=js"
export * from "./AgDetailDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fab3f",
  null
  
)

export default component.exports